import { render, staticRenderFns } from "./Taxonomy.vue?vue&type=template&id=6cc5c873&scoped=true"
import script from "./Taxonomy.vue?vue&type=script&lang=js"
export * from "./Taxonomy.vue?vue&type=script&lang=js"
import style0 from "./Taxonomy.vue?vue&type=style&index=0&id=6cc5c873&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc5c873",
  null
  
)

export default component.exports